import DiscipleHistoryContent from '../components/DiscipleHistoryContent';

export default function DiscipleHistory() {
  return <DiscipleHistoryContent />;
}